module.exports = __webpack_public_path__ + "img/banner.4e0af8e4.png";